/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Circle } from 'react-native-svg';

import { IconProps } from '../lib';

function DotsSixVertical(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Circle cx={92} cy={60} r={12} />
      <Circle cx={164} cy={60} r={12} />
      <Circle cx={92} cy={128} r={12} />
      <Circle cx={164} cy={128} r={12} />
      <Circle cx={92} cy={196} r={12} />
      <Circle cx={164} cy={196} r={12} />
    </Svg>
  );
}

export default DotsSixVertical;
